// react imports
import React, { useState } from "react";

// package imports
import { Row, Col } from "react-bootstrap";
import { observer } from "mobx-react";

// project imports
import { BottomsheetDropdown } from "components";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";

// CSS imports
// import "../../optimization-card/family-collapse-view.css";

const FlexiSavingsPlan = ({ form, data }) => {
 
  return (
    <div className=''>
      <div className='mx-0 my-4'>
        {/* <Col xs={12} md={6} className='mb-3'> */}
        {/* <p className='mb-2 font-size-12 font-weight-light '>{form.$("policy-term").label}</p> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("policy-term").label}
          menuList={form.$("policy-term").extra.optionList}
          value={form.$("policy-term").value}
          onSelect={form.$("policy-term").onChange}
        />
        {/* </Col> */}
      </div>

      <div className='mx-0 my-4'>
        {/* <Col xs={12} md={6} className='mb-3'> */}
        {/* <p className='mb-2 font-size-12 font-weight-light '>{form.$("premium-term").label}</p> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("premium-term").label}
          menuList={form.$("premium-term").extra.optionList}
          value={form.$("premium-term").value}
          onSelect={form.$("premium-term").onChange}
        />
      </div>
      {/* </Col> */}
      {/* {!form.$("accrual-of-survival-benefit").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <p className='mb-2 font-size-12 font-weight-light '>{form.$("accrual-of-survival-benefit").label}</p>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefit").label}
              menuList={form.$("accrual-of-survival-benefit").extra.optionList}
              value={form.$("accrual-of-survival-benefit").value}
              onSelect={form.$("accrual-of-survival-benefit").onChange}
              disabled={form.$("accrual-of-survival-benefit").disabled}
            />
          </Col>
        } */}

    </div>
  );
};

export default observer(FlexiSavingsPlan);
